import React from "react";

const SectionsIcon = ({ className }) => (
  <svg
    className={className}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M3.33325 5.00065C3.33325 4.55862 3.50885 4.1347 3.82141 3.82214C4.13397 3.50958 4.55789 3.33398 4.99992 3.33398H14.9999C15.4419 3.33398 15.8659 3.50958 16.1784 3.82214C16.491 4.1347 16.6666 4.55862 16.6666 5.00065V15.0007C16.6666 15.4427 16.491 15.8666 16.1784 16.1792C15.8659 16.4917 15.4419 16.6673 14.9999 16.6673H4.99992C4.55789 16.6673 4.13397 16.4917 3.82141 16.1792C3.50885 15.8666 3.33325 15.4427 3.33325 15.0007V5.00065Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.33325 3.33398L11.6666 16.6673"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.99992 10L3.33325 11.6667"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const TreeIcon = ({ className }) => (
  <svg
    className={className}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M10.0001 2.5L13.3334 5.83333L11.6667 6.66667L15.0001 10L12.5001 10.8333L15.8334 14.1667H4.16675L7.50008 10.8333L5.00008 10L8.33341 6.66667L6.66675 5.83333L10.0001 2.5Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.6666 14.166V16.666C11.6666 16.887 11.5788 17.099 11.4225 17.2553C11.2662 17.4116 11.0543 17.4993 10.8333 17.4993H9.16659C8.94557 17.4993 8.73361 17.4116 8.57733 17.2553C8.42105 17.099 8.33325 16.887 8.33325 16.666V14.166"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const RightPanelToggle = ({ activePanel, onChange }) => {
  const isSections = activePanel === "segments";
  const isTrees = activePanel === "trees";

  return (
    <div className="right-panel-toggle-bar">
      <button
        type="button"
        className={`right-panel-toggle-item ${isSections ? "is-active" : ""}`}
        onClick={() => onChange("segments")}
        aria-pressed={isSections}
      >
        <SectionsIcon className="right-panel-toggle-icon" />
        <span className="right-panel-toggle-label">Sections</span>
      </button>

      <span className="right-panel-toggle-divider" aria-hidden="true" />

      <button
        type="button"
        className={`right-panel-toggle-item ${isTrees ? "is-active" : ""}`}
        onClick={() => onChange("trees")}
        aria-pressed={isTrees}
      >
        <TreeIcon className="right-panel-toggle-icon" />
        <span className="right-panel-toggle-label">Trees</span>
      </button>
    </div>
  );
};

export default RightPanelToggle;
